import React, { Fragment } from 'react'

// components
import Header from '../Header/Header'
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'

// icons
import {
  faCalculator,
  faFileExcel,
  faPlus,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// services

// routes
import { withRouter } from 'react-router-dom'
import usePriceList from './hooks/usePriceList'

const ImportarListaPrecio = ({ history }) => {
  const {
    file,
    setFile,
    isLoading,
    handleImport,
  } = usePriceList()

  return (
    <Fragment>
      <Header />
      <div className="container-fluid mt-3">
        <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
          <BotonBack />
          <Subtitulo icon={faCalculator} title={'Lista de precios'} />
        </div>

        <div className="bg-gris p-4 position-relative">
          {isLoading && (
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 9999,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                color: 'white',
                fontSize: '1.5rem',
              }}
            >
              <div
                className="spinner-border text-light"
                role="status"
              />
              <div className="mt-3">
                Procesando importación...
              </div>
            </div>
          )}

          <form
            onSubmit={handleImport}
            encType="multipart/form-data"
          >
            <div className="form-row justify-content-center">
              <div className="form-group col-md-6">
                <label htmlFor="inputFile">
                  Seleccione un archivo
                </label>
                <div className="input-group-prepend">
                  <span
                    className="input-group-text"
                    id="inputGroupPrepend"
                  >
                    <FontAwesomeIcon icon={faFileExcel} />
                  </span>
                  <input
                    type="file"
                    id="inputFile"
                    name="fileCSV"
                    className="form-control"
                    placeholder="Ej. Precios actualizados..."
                    onChange={(e) =>
                      setFile(e.target.files[0])
                    }
                  />
                </div>
              </div>
            </div>

            <div className="text-center">
              <button
                type="submit"
                className="btn btn-outline-success"
                disabled={!file}
              >
                <FontAwesomeIcon icon={faPlus} /> Importar
              </button>
            </div>
          </form>
        </div>
      </div>
    </Fragment>
  )
}

export default withRouter(ImportarListaPrecio)
